import React from 'react';

// helpers
import {getDetailedFields, getSummaryFields} from './helpers';
import {useTranslation} from 'react-i18next';

// components
import {ProgressCircle} from '../../ProgressCircle';
import {LabelContentHorizontal} from '../../LabelContentHorizontal';
import {CardBorder} from '../../CardBorder';

// styles
import {
  MobileWrapper,
  MobileCircleWrapper,
  MobileContent,
  StyledLinkPrimary,
} from '../CardDetails-styles';
import {Subtitle} from '../../../styles';

// types
import {CardDetailsLoanProps} from './CardDetailsLoan';

const CardDetailsLoanMobile = ({loan, variant}: CardDetailsLoanProps) => {
  const {t} = useTranslation();

  /**
   * Render the fields based on the variant
   */
  const renderFields = () => {
    const fields =
      variant === 'detailed'
        ? getDetailedFields(loan, t)
        : getSummaryFields(loan, t);

    return fields.map(({label, content}) => (
      <LabelContentHorizontal
        key={label}
        label={label}
        content={content}
        isFullWidth
      />
    ));
  };

  return (
    <CardBorder variant="white" hasShadow>
      <MobileWrapper>
        {variant === 'summary' && (
          <Subtitle bold="bold">
            {`${t('loan_loanNumber')}${loan.loanNumber}`}
          </Subtitle>
        )}
        <MobileCircleWrapper>
          <ProgressCircle percentage={loan.percentagePaid} />
        </MobileCircleWrapper>
        <MobileContent>
          {renderFields()}
          {variant === 'summary' && (
            <StyledLinkPrimary href={`/loans/${loan.id}`}>
              {t('dashboard_seeMore')}
            </StyledLinkPrimary>
          )}
        </MobileContent>
      </MobileWrapper>
    </CardBorder>
  );
};

export default CardDetailsLoanMobile;
